<template>
  <div class="settings-badge-categories-container m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Badge Categories</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        @click="addBadgeCategory"
        variant="primary"
        >New Category</b-button
      >
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="list"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
    ></grid>
    <b-modal
      centered
      :title="form.id ? 'Edit Badge Category' : 'Add Badge Category'"
      v-model="showEditor"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitBadgeCategory"
      no-close-on-backdrop
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-form-group
        label="Name"
        :state="formErrors.name.length == 0 ? null : false"
        :invalid-feedback="formErrors.name.join(', ')"
      >
        <b-form-input
          v-model="form.name"
          maxLength="100"
          :state="formErrors.name.length == 0 ? null : false"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Color">
        <color-picker v-model="form.color" />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import ColorPicker from "../controls/ColorPicker.vue";
import { validateRequired } from "../../helpers/validation";
import badgeCategoriesServer from "../../server/badgeCategory";

export default {
  name: "EocBadgeCategoryCrud",
  components: { Grid, ColorPicker },
  data() {
    return {
      list: [],
      form: {
        id: undefined,
        name: "",
        color: ""
      },
      formErrors: {
        name: []
      },
      showEditor: false
    };
  },
  computed: {
    columns() {
      let columns = [];

      columns.push({
        text: "Name",
        field: "name",
        type: "template",
        width: 300,
        editor: false,
        template: data => data.record.data.name
      });

      columns.push({
        text: "Color",
        field: "color",
        type: "template",
        align: "center",
        width: 70,
        template: data => {
          return `<div class="d-flex w-100 justify-content-center"><div class="small-square" style="background-color:${
            data.record.data.color ? data.record.data.color : "black"
          };"></div></div>`;
        }
      });

      columns.push({
        text: "Actions",
        field: "actions",
        type: "action",
        cellCls: "pointer-cell",
        align: "right",
        width: 100,
        actions: [
          {
            tooltip: "Edit",
            renderer: () =>
              `<img class="b-action-item" src="${
                this.isStandalone()
                  ? `/icons/edit.svg`
                  : `/desktop/icons/edit.svg`
              }">`,
            onClick: ({ record }) => {
              this.showEditor = true;
              this.form = { ...record.originalData };
            }
          },
          {
            tooltip: "Delete",
            renderer: () =>
              `<img class="b-action-item ml-2" src="${
                this.isStandalone()
                  ? `/icons/delete.svg`
                  : `/desktop/icons/delete.svg`
              }">`,
            onClick: ({ record }) => {
              this.$dialog
                .confirm(
                  {
                    title: "Are you sure you want to delete this record?"
                  },
                  {
                    view: "confirm-delete"
                  }
                )
                .then(
                  async () => await this.deleteBadgeCategory(record.data.id)
                )
                .catch(function() {});
            }
          }
        ]
      });

      return columns;
    }
  },
  mounted() {
    this.getBadgeCategories();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    async getBadgeCategories() {
      this.list = await badgeCategoriesServer.query();
    },
    addBadgeCategory() {
      Object.assign(this.form, {
        id: undefined,
        name: "",
        color: "#16aaff"
      });

      this.showEditor = true;
    },
    async submitBadgeCategory(modalEvent) {
      modalEvent.preventDefault();
      const validForm = this.validateForm();
      if (validForm) {
        const data = { name: this.form.name, color: this.form.color };
        if (!this.form.id) {
          await badgeCategoriesServer.create(data);
        } else {
          await badgeCategoriesServer.update(this.form.id, data);
        }

        this.showEditor = false;
        this.showAlertSuccess();
        await this.getBadgeCategories();
      }
    },
    async deleteBadgeCategory(id) {
      await badgeCategoriesServer.delete(id);
      this.showAlertSuccess();
      await this.getBadgeCategories();
    },
    validateForm() {
      this.formErrors.name.splice(0);

      if (!validateRequired(this.form.name)) {
        this.formErrors.name.push("This field is required");
        return false;
      }

      return true;
    }
  }
};
</script>

<style>
.settings-badge-categories-container .b-grid-container .b-container {
  max-height: calc(100vh - 281px);
}
</style>
